
import { mapState, mapGetters, mapActions } from 'vuex';
import PreferredFitType from '@/enums/PreferredFitType';
import SizeRecommendationBadge from './SizeRecommendationBadge';
import LocalStorageKeys from '@/constants/LOCAL_STORAGE_KEYS';

const HEIGHT_MIN = 130;
const HEIGHT_MAX = 210;
const WEIGHT_MIN = 20;
const WEIGHT_MAX = 150;

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationInputView',
  name: 'SizeRecommendationInputView',
  components: { SizeRecommendationBadge },
  data() {
    return {
      isLoading: true,
      product: null,
      selectedPreferredFitType: null
    };
  },
  computed: {
    ...mapState(['productCode', 'api']),
    ...mapState('session', ['sessionParams']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('form', ['formValues']),
    ...mapGetters('form', ['hasErrors']),
    ...mapGetters('session', ['isLoggedIn']),
    submitButtonStyle() {
      return {
        '--submit-bg-color': this.reviewSettings.main_color
      };
    },
    isSubmitDisabled() {
      return (
        this.formValues.height === null ||
        this.formValues.weight === null ||
        this.selectedPreferredFitType === null ||
        this.hasErrors
      );
    },
    PreferredFitType() {
      return PreferredFitType;
    },
    fields() {
      return [
        {
          key: 'height',
          type: 'number',
          labelName: this.$t('height.labelName'),
          labelUnit: this.$t('height.labelUnit'),
          inputProps: {
            placeholder: this.$t('height.placeholder'),
            maxlength: 3,
            size: 'large'
          }
        },
        {
          key: 'weight',
          type: 'number',
          labelName: this.$t('weight.labelName'),
          labelUnit: this.$t('weight.labelUnit'),
          inputProps: {
            placeholder: this.$t('weight.placeholder'),
            maxlength: 3,
            size: 'large'
          }
        }
      ];
    }
  },
  created() {
    this.setValidationRules({
      height: {
        range: v =>
          v === null ||
          (v >= HEIGHT_MIN && v <= HEIGHT_MAX) ||
          this.$t('height.error')
      },
      weight: {
        range: v =>
          v === null ||
          (v >= WEIGHT_MIN && v <= WEIGHT_MAX) ||
          this.$t('weight.error')
      }
    });
    this.fetchInitialData();
  },
  methods: {
    ...mapActions('form', [
      'setFormValues',
      'setValidationRules',
      'validateAll'
    ]),
    ...mapActions('userProperties', ['fetchUserProperties']),
    async fetchInitialData() {
      try {
        await Promise.all([this.initFormValues(), this.fetchProductSummary()]);
      } finally {
        this.isLoading = false;
      }
    },
    async initFormValues() {
      if (this.isLoggedIn) {
        await this.fetchUserProperties({
          product_code: this.productCode,
          ...this.sessionParams
        });
      }
      const savedHeight = JSON.parse(
        localStorage.getItem(LocalStorageKeys.USER_HEIGHT)
      );
      const savedWeight = JSON.parse(
        localStorage.getItem(LocalStorageKeys.USER_WEIGHT)
      );
      this.setFormValues({ height: savedHeight, weight: savedWeight });
    },
    async fetchProductSummary() {
      const { data } = await this.api.fetchProductSummary(this.productCode);
      this.product = data;
    },
    async onSubmit() {
      const isValid = await this.validateAll();
      if (!isValid) return;
      localStorage.setItem(
        LocalStorageKeys.USER_HEIGHT,
        this.formValues.height
      );
      localStorage.setItem(
        LocalStorageKeys.USER_WEIGHT,
        this.formValues.weight
      );
      this.$emit('submit', {
        height: this.formValues.height,
        weight: this.formValues.weight,
        preferredFitType: this.selectedPreferredFitType
      });
    }
  }
};
